import moment from 'moment'
import 'moment/dist/locale/fr-ch'
import 'moment/dist/locale/nl-be'
import 'moment/dist/locale/nl'
import 'moment/dist/locale/es'
import 'moment/dist/locale/fr'
import 'moment/dist/locale/ro'
import i18n from '@src/i18n'

export default {
  getCompareDates(compare, startDate, endDate) {
    if (compare === 'day') {
      return [
        moment(startDate).add(-1, 'days'),
        moment(endDate).add(-1, 'days')
      ]
    } else if (compare === 'week') {
      return [
        moment(startDate).add(-1, 'weeks'),
        moment(endDate).add(-1, 'weeks')
      ]
    } else if (compare === 'month') {
      return [
        moment(startDate).add(-1, 'months'),
        moment(endDate).add(-1, 'months')
      ]
    } else if (compare === 'quarter') {
      return [
        moment(startDate).add(-1, 'quarters'),
        moment(endDate).add(-1, 'quarters')
      ]
    } else if (compare === 'year') {
      return [
        moment(startDate).add(-1, 'years'),
        moment(endDate).add(-1, 'years')
      ]
    }
    return [moment(startDate), moment(endDate)]
  },
  getRelativeDateAsArray(period) {
    if (period === 'today') {
      return [moment(), moment()]
    } else if (period === 'tomorrow') {
      return [moment().add(1, 'day'), moment().add(1, 'day')]
    } else if (period === 'yesterday') {
      return [moment().add(-1, 'day'), moment().add(-1, 'day')]
    } else if (period === 'these_3_days') {
      return [moment(), moment().add(2, 'days')]
    } else if (period === 'next_3_days') {
      return [moment().add(1, 'day'), moment().add(3, 'days')]
    } else if (period === 'these_5_days') {
      return [moment(), moment().add(4, 'days')]
    } else if (period === 'next_5_days') {
      return [moment().add(1, 'day'), moment().add(5, 'days')]
    } else if (period === 'these_7_days') {
      return [moment(), moment().add(6, 'days')]
    } else if (period === 'next_7_days') {
      return [moment().add(1, 'day'), moment().add(7, 'days')]
    } else if (period === 'last_7_days') {
      return [moment().add(-6, 'days'), moment()]
    } else if (period === 'these_10_days') {
      return [moment(), moment().add(9, 'days')]
    } else if (period === 'next_10_days') {
      return [moment().add(1, 'day'), moment().add(10, 'days')]
    } else if (period === 'last_10_days') {
      return [moment().add(-9, 'days'), moment()]
    } else if (period === 'last_3_days') {
      return [moment().add(-2, 'days'), moment()]
    } else if (period === 'last_5_days') {
      return [moment().add(-4, 'days'), moment()]
    } else if (period === 'this_week') {
      return [moment().startOf('week'), moment().endOf('week')]
    } else if (period === 'last_week') {
      return [
        moment().startOf('week').add(-1, 'week'),
        moment().endOf('week').add(-1, 'week')
      ]
    } else if (period === 'next_week') {
      return [
        moment().startOf('week').add(1, 'week'),
        moment().endOf('week').add(1, 'week')
      ]
    } else if (period === 'this_month') {
      return [moment().startOf('month'), moment().endOf('month')]
    } else if (period === 'last_month') {
      return [
        moment().add(-1, 'month').startOf('month'),
        moment().add(-1, 'month').endOf('month')
      ]
    } else if (period === 'next_month') {
      return [
        moment().add(1, 'month').startOf('month'),
        moment().add(1, 'month').endOf('month')
      ]
    } else if (period === 'last_30_days') {
      return [moment().add(-29, 'days'), moment()]
    } else if (period === 'these_30_days') {
      return [moment(), moment().add(29, 'days')]
    } else if (period === 'next_30_days') {
      return [moment().add(1, 'day'), moment().add(30, 'days')]
    } else if (period === 'this_quarter') {
      return [moment().startOf('quarter'), moment().endOf('quarter')]
    } else if (period === 'last_quarter') {
      return [
        moment().add(-1, 'quarter').startOf('quarter'),
        moment().add(-1, 'quarter').endOf('quarter')
      ]
    } else if (period === 'next_quarter') {
      return [
        moment().add(1, 'quarter').startOf('quarter'),
        moment().add(1, 'quarter').endOf('quarter')
      ]
    } else if (period === 'last_90_days') {
      return [moment().add(-89, 'days'), moment()]
    } else if (period === 'these_90_days') {
      return [moment(), moment().add(89, 'days')]
    } else if (period === 'next_90_days') {
      return [moment().add(1, 'day'), moment().add(90, 'days')]
    } else if (period === 'this_year') {
      return [moment().startOf('year'), moment().endOf('year')]
    } else if (period === 'last_year') {
      return [
        moment().add(-1, 'year').startOf('year'),
        moment().add(-1, 'year').endOf('year')
      ]
    } else if (period === 'next_year') {
      return [
        moment().add(1, 'year').startOf('year'),
        moment().add(1, 'year').endOf('year')
      ]
    } else if (period === 'last_365_days') {
      return [moment().add(-364, 'days'), moment()]
    } else if (period === 'these_365_days') {
      return [moment(), moment().add(364, 'days')]
    } else if (period === 'next_365_days') {
      return [moment().add(1, 'day'), moment().add(365, 'days')]
    }
  },
  getRelativeDateString(period, format, locale) {
    if (format === undefined) {
      format = 'LL'
    }
    if (locale === undefined) {
      locale = this._getCurrentLocaleForMomentJs()
    }
    let [start, end] = this.getRelativeDateAsArray(period)
    if (start.isSame(end, 'day')) {
      return start.locale(locale).format(format)
    }
    return `${start.locale(locale).format(format)} - ${end
      .locale(locale)
      .format(format)}`
  },
  getNumberOfDaysBetweenDates(start, end) {
    let startm = moment(start)
    let endm = moment(end)
    return endm.diff(startm, 'days')
  },
  getDateRangeString(start, end, format, locale) {
    if (format === undefined) {
      format = 'LL'
    }
    if (locale === undefined) {
      locale = this._getCurrentLocaleForMomentJs()
    }
    let startm = moment(start)
    let endm = moment(end)
    if (startm.isSame(endm, 'day')) {
      return startm.locale(locale).format(format)
    }
    return `${startm.locale(locale).format(format)} - ${endm
      .locale(locale)
      .format(format)}`
  },
  _getCurrentLocaleForMomentJs() {
    switch (i18n.vueI18n.global.locale) {
      case 'fr_BE':
      case 'fr_FR':
        return 'fr'
      case 'fr_CH':
        return 'fr-ch'
      case 'nl_BE':
        return 'nl-be'
      case 'nl_NL':
        return 'nl'
      default:
        return 'en'
    }
  },
  formatDate(date, format, locale) {
    locale = locale !== undefined ? locale : this._getCurrentLocaleForMomentJs()
    let _moment = moment(date)
    return _moment.isValid() ? _moment.locale(locale).format(format) : ''
  },
  momentLocalised(date, format, locale) {
    if (locale === undefined) {
      locale = this._getCurrentLocaleForMomentJs()
    }
    return moment(date).locale(locale).format(format)
  },
  durationHumanized(duration, locale, units) {
    if (locale === undefined) {
      locale = this._getCurrentLocaleForMomentJs()
    }
    if (units === undefined) {
      units = 'minutes'
    }
    return moment.duration(duration, units).locale(locale).humanize()
  },
  formatDateAndDiff(date, format, locale) {
    locale = locale !== undefined ? locale : this._getCurrentLocaleForMomentJs()
    return `${this.formatDate(date, format, locale)} (${moment(date)
      .locale(locale)
      .fromNow()})`
  },
  // region BBSW-7353 - visit opening hours, per weekday
  // moment().day() gives 0 for Sunday through 6 for Saturday, so this array is indexed that way
  // on purpose. Never use it to drive display order: the settings screen lists Monday first.
  visitWeekdaySettingKeys(date) {
    const days = [
      'sunday',
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday'
    ]
    const day = days[moment(date).day()]

    return {
      enabled: `visit_${day}_enabled`,
      start: `visit_${day}_start_time`,
      end: `visit_${day}_end_time`
    }
  },
  // Opening hours and closed days only apply once "default time" is ticked for visits: the
  // settings screen hides them otherwise, and the back defaults the legacy pair to '00:00',
  // which would override the previous visit's hours for every tenant that never set anything.
  hasVisitOpeningHours(settings) {
    const value = settings?.visit_default_time

    return Boolean(value) && value !== '0' && value !== 'false'
  },
  // A missing key means the API predates this setting: treat the day as open rather than
  // silently closing the whole week.
  isVisitDayEnabled(settings, date) {
    if (!this.hasVisitOpeningHours(settings)) {
      return true
    }

    const value = settings?.[this.visitWeekdaySettingKeys(date).enabled]

    return value !== false && value !== 0 && value !== '0'
  },
  // Walks forward to the first day the funeral home receives visitors. If all seven days are
  // closed, gives the original date back instead of looping forever.
  nextEnabledVisitDate(settings, date) {
    const candidate = moment(date)

    for (let index = 0; index < 7; index++) {
      if (this.isVisitDayEnabled(settings, candidate)) {
        return candidate
      }
      candidate.add(1, 'd')
    }

    return moment(date)
  },
  // Times configured for that weekday, falling back to the legacy funeral-home-wide pair when the
  // day has none. Null means "not set".
  visitTimesForDate(settings, date) {
    if (!this.hasVisitOpeningHours(settings)) {
      return { startTime: null, endTime: null }
    }

    const keys = this.visitWeekdaySettingKeys(date)

    const resolve = (dayKey, legacyKey) => {
      if (this.isValidTime(settings?.[dayKey])) {
        return settings[dayKey]
      }
      if (this.isValidTime(settings?.[legacyKey])) {
        return settings[legacyKey]
      }

      return null
    }

    return {
      startTime: resolve(keys.start, 'visit_default_start_time'),
      endTime: resolve(keys.end, 'visit_default_end_time')
    }
  },
  // Whether that day's visit slot has already started. With no configured time, the day stays
  // open until midnight rather than being ruled out.
  isVisitSlotPast(settings, date) {
    const day = moment(date)
    const { startTime } = this.visitTimesForDate(settings, day)
    const slotStart = startTime
      ? moment(`${day.format('YYYY-MM-DD')} ${startTime}`, 'YYYY-MM-DD HH:mm')
      : day.clone().endOf('day')

    return !moment().isBefore(slotStart)
  },
  // Days proposed by the "Automatique" popup (BBSW-7334): from the anchor day up to, but not
  // including, the funeral. Visits stop the day before it.
  //
  // Every day can be picked, past ones included: starting from the death date lets the advisor
  // encode visits that already took place. Only upcoming slots are preselected, so nothing is
  // created in the past without being asked for. The anchor day is never preselected either: the
  // user opened this popup to plan the days that follow.
  //
  // A day the funeral home keeps closed is listed but not preselected either, so the user sees
  // why it was skipped instead of wondering where it went.
  visitScheduleBetween(settings, fromDate, toDate) {
    const start = moment(fromDate).startOf('day')
    const end = moment(toDate).startOf('day')
    const rows = []

    if (!start.isValid() || !end.isValid()) {
      return rows
    }

    const cursor = start.clone()

    // More than 10 visit days is not a real case; the cap keeps a funeral date wrongly encoded far
    // ahead from proposing weeks of visits.
    while (cursor.isBefore(end) && rows.length < 10) {
      const times = this.visitTimesForDate(settings, cursor)
      const enabled = this.isVisitDayEnabled(settings, cursor)
      const isAnchor = cursor.isSame(start, 'day')
      const isPast = this.isVisitSlotPast(settings, cursor)

      rows.push({
        date: cursor.format('YYYY-MM-DD'),
        isAnchor,
        isPast,
        enabled,
        selected: !isAnchor && !isPast && enabled,
        startTime: times.startTime ?? '',
        endTime: times.endTime ?? ''
      })

      cursor.add(1, 'd')
    }

    return rows
  },
  // endregion
  isValidTime(value) {
    // Vérifie que la valeur existe, n'est pas vide
    if (!value || typeof value !== 'string') return false

    // Regex pour le format 00:00 -> 23:59
    const regex = /^([01]\d|2[0-3]):[0-5]\d$/
    return regex.test(value)
  },
  rangeDateAsString(
    date_from,
    date_to,
    day_format = 'dddd DD MMMM',
    time_format = 'HH:mm',
    locale
  ) {
    locale = locale !== undefined ? locale : this._getCurrentLocaleForMomentJs()
    let mFrom = moment(date_from)
    let mTo = moment(date_to)
    if (mFrom.isSame(mTo, 'day')) {
      return `${mFrom.locale(locale).format(`${day_format} ${time_format}`)} - ${mTo.locale(locale).format(time_format)}`
    }
    return `${mFrom.locale(locale).format(`${day_format} ${time_format}`)} - ${mTo.locale(locale).format(`${day_format} ${time_format}`)}`
  }
}
